module.exports = __webpack_public_path__ + "2a93c39f82730d049cd2342a51bae9a1.jpg";